import React from 'react';
import styles from './Reminder.module.sass'
import { withRouter } from "react-router";

function Reminder(props) {
    return (
        <div className={styles.content}>
            <p><strong>Importante lembrar: </strong>{props.text}</p>
        </div>
    )
}

export default withRouter(Reminder);
